import Vue from 'vue'
import Router from 'vue-router'
import Init from '../components/Init.vue'
import Login from '../components/Login.vue'
import Logout from '../components/Logout.vue'
import Home from '../components/Home.vue'
import News from '../components/News.vue'
import Mengen from '../components/Mengen.vue'
import Einlieferungen from '../components/Einlieferungen.vue'
import Lieferrecht from '../components/Lieferrecht.vue'
import Labels from '../components/Labels.vue'
import Mengenvermittlung from '../components/Mengenvermittlung.vue'
import Mengenuebertragung from '../components/Mengenuebertragung.vue'
import AnalysenTabelle from '../components/AnalysenTabelle.vue'
import AnalysenGrafik from '../components/AnalysenGrafik.vue'
import AnalysenSaST from '../components/AnalysenSaST.vue'
import Datenpakete from '../components/Datenpakete/Datenpakete.vue'
//import Selbstdeklaration from '../components/Datenpakete/SelbstdeklarationGT.vue'
import Beziehungen from '../components/Datenpakete/Beziehungen.vue'
import Paketdaten from '../components/Datenpakete/Paketdaten.vue'
import Kriterien from '../components/Datenpakete/Kriterien.vue'
import Dokumente from '../components/Dokumente.vue'
import Einladungen from '../components/Einladungen.vue'
import Kontakt from '../components/Kontakt.vue'
//import FAQ from '../components/FAQ.vue'
import Profil from '../components/Profil.vue'
import SmsPinCodes from '../components/SmsPinCodes.vue'
//import Betriebe from '../components/Betriebe.vue'
import Timeout from '../components/Timeout.vue'
import Zulagen from '../components/Zulagen.vue'


Vue.use(Router);
export default new Router({
    routes: [
        {
            path: '/:lang/init',
            name: 'Init',
            component: Init,
        },
        {
            path: '/:lang/login/:jwt/:next',
            name: 'Login',
            component: Login,
        },
        {
            path: '/:lang/login/:jwt',
            name: 'Login',
            component: Login,
        },
        {
            path: '/:lang/login',
            name: 'Login',
            component: Login,
        },
        {
            path: '/:lang/logout',
            name: 'Logout',
            component: Logout,
        },
        {
            path: '/:lang/home',
            name: 'HomeHome',
            component: Home,
        },
        {
            path: '/:lang/news/:domID',
            name: 'Aktuelles',
            component: News,
            //props: true,
            props(route) {
                const props = { ...route.params }
                props.domID = +props.domID
                props.conID = 0
                return props
            },
        },
        {
            path: '/:lang/news/:domID/:conID',
            name: 'ReiterAktuelles',
            component: News,
            //props: true,
            props(route) {
                const props = { ...route.params }
                props.domID = +props.domID
                props.conID = +props.conID
                return props
            },
        },
        {
            path: '/:lang/beziehungen',
            name: 'Beziehungen',
            component: Beziehungen,
        },
        {
            path: '/:lang/mengen',
            name: 'VermarkteteMilch',
            component: Mengen,
        },
        {
            path: '/:lang/einlieferungen',
            name: 'Einlieferungen',
            component: Einlieferungen,
        },
        {
            path: '/:lang/lieferrecht',
            name: 'Lieferrecht',
            component: Lieferrecht,
        },
        {
            path: '/:lang/labels',
            name: 'Labels',
            component: Labels,
        },
        {
            path: '/:lang/mengenvermittlung',
            name: 'Mengenvermittlung',
            component: Mengenvermittlung,
        },
        {
            path: '/:lang/mengenuebertragung',
            name: 'Mengenuebertragung',
            component: Mengenuebertragung,
        },
        {
            path: '/:lang/analysen/grafik', // show kann grafik oder tabelle sein und geht via Props in Analysen.vue
            name: 'AnalysenGrafik',
            component: AnalysenGrafik,
            props(route) {
                const props = { ...route.params }
                props.show = 'tabelle'
                return props
            },
        },
        {
            path: '/:lang/analysen/tabelle', // show kann grafik oder tabelle sein und geht via Props in Analysen.vue
            name: 'AnalysenTabelle',
            component: AnalysenTabelle,
            props(route) {
                const props = { ...route.params }
                props.show = 'tabelle'
                return props
            },
        },
        {
            path: '/:lang/analysen',
            name: 'Analysen',
            //component: Analysen,
            redirect: to => { return '/' + to.params.lang + '/analysen/tabelle' }
            /*
            props(route) {
                const props = {...route.params}
                props.show='tabelle',
                return props
              },
            */
        },
        {
            path: '/:lang/analysen_sast',
            name: 'AnalysenSaST',
            component: AnalysenSaST,
        },
        {
            path: '/:lang/datenpakete',
            name: 'Datenfreigaben',
            component: Datenpakete,
            /*props(route) {
                return {...route.params}
            }*/
            props: true,
        },
        {
            path: '/:lang/paketdaten',
            name: 'Paketdaten',
            component: Paketdaten,
        },
        {
            path: '/:lang/kriterien',
            name: 'Kriterien',
            component: Kriterien,
        },
        {
            path: '/:lang/dokumente',
            name: 'Briefkasten',
            //component: Dokumente, /* weiterleiten damit ein Jahr selektiert ist, refreshprobleme bei gewissen Browsern Jan 2020 */
            redirect: to => {
                let year = new Date().getFullYear();
                return '/' + to.params.lang + '/dokumente/' + year
            }
        },
        {
            path: '/:lang/dokumente/:year',
            name: 'Briefkasten',
            component: Dokumente,
            props(route) {
                const props = { ...route.params }
                props.year = +props.year
                return props
            },
        },
        {
            path: '/:lang/einladungen',
            name: 'Einladungen',
            //component: Einladungen,
        },
        {
            path: '/:lang/einladungen/:year',
            name: 'Einladungen',
            component: Einladungen,
            props(route) {
                const props = { ...route.params }
                props.year = +props.year
                return props
            },
        },
        {
            path: '/:lang/einladungen/:year/:EinPubMsgID',
            name: 'Einladungen',
            component: Einladungen,
            props(route) {
                const props = { ...route.params }
                props.year = +props.year
                props.EinPubMsgID = +props.EinPubMsgID
                return props
            },
        },
        {
            path: '/:lang/kontakt',
            name: 'Kontakt',
            component: Kontakt,
        },
        {
            path: '/:lang/profil',
            name: 'Profil',
            component: Profil,
        },
        {
            path: '/:lang/smspincodes',
            name: 'SmsPinCodes',
            component: SmsPinCodes,
        },
        /*
                {
                    path: '/:lang/betriebe',
                    name: 'Betriebe',
                    component: Betriebe,
                },
        */
        {
            path: '/:lang/timeout',
            name: 'Timeout',
            component: Timeout,
        },
        {
            path: '/:lang/zulagen',
            name: 'Zulagen',
            component: Zulagen,
        },

        { path: '*', redirect: '/de/logout' }
    ]
})